<template>
  <div class="about w-full sm:w-3/5 md:w-2/5 mx-auto p-2">
    <h1 class="font-display text-2xl text-pink-500 text-center">Manage transactions</h1>

    <div class="text-center my-6">
      <router-link class="text-gray-800 border-b border-pink-500" to="/add-transaction">Add</router-link>
    </div>

    <div class="text-center my-6">
      <router-link class="text-gray-800 border-b border-pink-500" to="/reports">Create report</router-link>
    </div>

    <div class="text-center my-6">
      <router-link class="text-gray-800 border-b border-pink-500" to="/tax-day">Set tax day</router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      test: ""
    };
  }
};
</script>

